import React from "react";
import {AppSettings} from "../../../../AppSettings";
import {getIdWithToken, getToken, getUserNameWithToken} from "../../../../utils/storage/Token";
import {OutlayItemInterface} from "../../../../service/Business/Interfaces/OutlayInterface";

type InputFileTableProps = {
    edit: boolean;
    outlayItem: OutlayItemInterface;
    nameOutlay: string;
    onChangeHandler?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

const InputFileTable: React.FunctionComponent<InputFileTableProps> = (props) => {

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files[0]) {
            if (event.target.files[0].size > MAX_FILE_SIZE) {
                alert("Le fichier dépasse la taille maximale autorisée (10 Mo).");
                event.target.value = "";
                return;
            }
        }
        if (props.onChangeHandler) {
            props.onChangeHandler(event);
        }
    };

    const handleClickItem = () => {
        const url = `stockage_volume/${getUserNameWithToken()}/Debours/${props.nameOutlay.replaceAll(" ", "_")}/${props.outlayItem.nameFile}`
        const rawToken = getToken()?.replace("Bearer ", "") || "";
        window.open(`${AppSettings.API_ENDPOINT}${AppSettings.API_FREELANCERIE}/explorer/view/${getIdWithToken().toString()}/${encodeURIComponent(url)}?token=${rawToken}`, "_blank");
    }

    return (
        <React.Fragment>
            {props.edit
                ? <input className="ctcInput" type="file" accept="image/png, image/jpeg, .pdf"
                         onChange={handleFileChange}/>
                : props.outlayItem.receiptLoaded
                    ? <span className="material-symbols-outlined"
                             style={{color: "var(--color-success)", cursor: "pointer", fontSize: 20}}
                             onClick={handleClickItem}
                             title="Voir le justificatif">
                        receipt
                      </span>
                    : <span className="material-symbols-outlined"
                             style={{color: "var(--color-error)", fontSize: 20}}
                             title="Aucun justificatif">
                        close
                      </span>
            }
        </React.Fragment>
    );

}

export default InputFileTable;